export const facebookGraphApiVersion = '3.3';
export const facebookAppId = '1276030352501030';

export const DASHBO_DOMAIN = 'www.dashbo.io';

export const ERROR_AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT = "AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT"

// Los contactos de Dashbo que la app ofrece fuera del chat. Un solo lugar: hasta el 15/10 el
// botón de demo del Tablero llevaba al Calendly de Pablo, que dejó Dashbo el 22/09 (UD-3 de /ux).
// El número de WhatsApp vive además en otros dos lugares, que no gobiernan éste: el sitio
// (`dashbo-sitio/src/lib/config.ts`, junto con el Calendly) y el Backend (`FEEDBACK_WHATSAPP_URL` en
// `monitor_api/settings.py`, editable desde el CC para el widget de feedback). Si cambia, son tres.
export const DEMO_CALENDLY_URL = 'https://calendly.com/fedeserbin/demo';
export const DASHBO_WHATSAPP_URL = 'https://wa.me/5491173329974';

// La demo grabada (8:53), la misma que mandan los correos del motor de seguimiento en modo ausente
// (CC → Seguimiento → Ajustes → «Demo grabada»). La ofrece «Sigues desde la computadora» del alta en
// el celular (UD-23 de /ux). Si cambia el video, son dos lugares.
export const DEMO_VIDEO_URL = 'https://youtu.be/BARX9K4gwXQ';

// El proyecto de Microsoft Clarity de la app (UD-7 de /ux, 18/10): graba sólo el alta y las agencias en
// prueba o vencidas sin pagar, en modo estricto (`utils/clarity/`). No es el del sitio (`yulbinbhsi`).
// No es un secreto: viaja en el bundle como en cualquier tag. VACÍO = APAGADO: apagarlo es dejar '' y deployar.
export const CLARITY_APP_PROJECT_ID = 'yzu8qyhfwo';

// El link de la demo con `utm_source=app` y la pantalla de origen, para que la reserva diga de
// dónde vino (Calendly guarda los utm de cada reserva).
export function demoCalendlyUrl(campaign) {
    return `${DEMO_CALENDLY_URL}?utm_source=app&utm_campaign=${encodeURIComponent(campaign)}`;
}

